import { useQuery } from "react-query";
import { getWidgetInstancesByRole } from "../../services/widget-instance-service";
import widgetInstanceKeys from "queryKeyFactory/widgetInstanceKeys";

type Params = {
    select?: (res: any) => any;
    roleId: string | null;
    successCb?: (data: any) => void;
}


export default function useGetWidgetInstancesByRole<T>(params?: Params) {
    const select = params?.select
    const roleId = params?.roleId ?? ""

    return useQuery<any, Error, T>({
        queryKey: widgetInstanceKeys.widgetInstancesByRole(roleId),
        enabled: !!roleId,
        queryFn: () => getWidgetInstancesByRole(roleId),
        select,
        onSuccess: params?.successCb,
        refetchOnWindowFocus: false,
    })
}